import React from 'react';
import { FaUsers, FaUserPlus, FaCrown, FaExchangeAlt } from 'react-icons/fa';

const UserStats = ({ totalUsers, newUsersWeek, newUsersMonth, activeSubscribers, conversionRate }) => {
  return (
    <div className="stats-card user-stats">
      <h2>User Statistics</h2>
      <div className="stats-grid">
        <div className="stat-item">
          <div className="stat-icon">
            <FaUsers />
          </div>
          <div className="stat-content">
            <h3>Total Users</h3>
            <p className="stat-value">{totalUsers}</p>
          </div>
        </div>

        <div className="stat-item">
          <div className="stat-icon">
            <FaUserPlus />
          </div>
          <div className="stat-content">
            <h3>New Users (Week)</h3>
            <p className="stat-value">{newUsersWeek}</p>
          </div>
        </div>

        <div className="stat-item">
          <div className="stat-icon">
            <FaUserPlus />
          </div>
          <div className="stat-content">
            <h3>New Users (Month)</h3>
            <p className="stat-value">{newUsersMonth}</p>
          </div>
        </div>

        <div className="stat-item">
          <div className="stat-icon">
            <FaCrown />
          </div>
          <div className="stat-content">
            <h3>Active Subscribers</h3>
            <p className="stat-value">{activeSubscribers}</p>
          </div>
        </div>

        <div className="stat-item">
          <div className="stat-icon">
            <FaExchangeAlt />
          </div>
          <div className="stat-content">
            <h3>Conversion Rate</h3>
            <p className="stat-value">{conversionRate}%</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserStats;